import { render, staticRenderFns } from "./EditActMirror.vue?vue&type=template&id=405e8116&scoped=true&"
import script from "./EditActMirror.vue?vue&type=script&lang=js&"
export * from "./EditActMirror.vue?vue&type=script&lang=js&"
import style0 from "./EditActMirror.vue?vue&type=style&index=0&id=405e8116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e8116",
  null
  
)

export default component.exports